import { makeStyles, useTheme } from "@material-ui/core/styles";
import transitions from "@material-ui/core/styles/transitions";


const drawerWidth = 280;

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  // menuButton: {
  //   marginRight: 36,
  // },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    boxShadow: '15px 0 12px -2px #f0eaea !important',
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    boxShadow: '15px 0 12px -2px #f0eaea !important',
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
   
    }),
    overflowX: "hidden",
    // minWidth: '65px',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
     
    },

    "& .MuiListItem-root":{
      width: '60px',
      display: 'flex',
      position: 'relative',
      boxSizing: 'border-box',
      textAlign: 'left',
      alignItems: 'center',
      paddingTop: '8px',
      paddingBottom: '8px',
      justifyContent: 'flex-start',
      textDecoration: 'none',
      borderRadius: '15px',
      margin: '2px 0 2px 5px',
      //background: '#ed1c24', 
    },

    "& .bganimate":{
      animation: '$animatedBg alternate 1000ms infinite',
    },

    "& .MuiListItem-root:hover":{
      background: '#ed1c24',
      borderRadius: '15px',
      margin: '2px 0 2px 5px',
      width: '60px',
      "& .MuiSvgIcon-root":{
        color:'#fff',
      },

    },
  },
  leftToolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },

  infoSectionToolbar: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  
  footerTxtWrapper:{
    color:'#535353  !important',
    transform:'rotate(-90deg) !important',
    bottom:'105px',
    position: 'fixed',
    left: '-50px',
    textTransform:'uppercase',
    fontSize:'11px',
},
menuBtnWrapper:{
  "& button:hover":{
    backgroundColor:'#fff !important',
  },
  "& button.selected":{
    backgroundColor:'#fff !important',
  },
  "& .MuiIconButton-root":{
      background:'#fff !important',
  },
},
menuButton: {
  color: '#000 !important',
  margin: '0 0px 0 -24px !important',
  padding: '25px 29px 26px 20px !important',
  background: '#fff !importnat',
  borderRadius: '0 !important',
  boxShadow: '15px 0 12px -2px #f0eaea !important',
},
content: {
    flexGrow: 1,
    padding: theme.spacing(3),
},
toolbar: theme.mixins.toolbar,

"@keyframes animatedBg": {
  from: { background: "#eb6c71  opacity: 0" },
  to: { background: "#eb6c71" }
}

}
));

export default useStyles;